import { FormattedMessage } from 'react-intl';
import {
  getIsPrintBtnLoading,
  getIsPrintBtnDisabled,
  getPrintBtnDisabledOnRowFiltering,
  getCutOffDisablePrintBtn
} from 'pages/VendorsTablePage/components/PrintChecks/slice';
import { useAppSelector } from 'store/hooks';
import { StyledHeaderButton } from '../styled';
import { PrintChecksHeaderButtonProps } from './types';

export const PrintChecksHeaderButton = ({
  handlePrintCheckButtonClick
}: PrintChecksHeaderButtonProps): React.JSX.Element => {
  const isPrintBtnLoading = useAppSelector(getIsPrintBtnLoading);
  const isPrintBtnDisabled = useAppSelector(getIsPrintBtnDisabled);
  const printBtnDisabledOnRowFiltering = useAppSelector(
    getPrintBtnDisabledOnRowFiltering
  );
  const cutOffPrintBtnDisabled = useAppSelector(getCutOffDisablePrintBtn);

  return (
    <StyledHeaderButton
      dataTestId="print-checks-button"
      onClick={handlePrintCheckButtonClick}
      text={
        <FormattedMessage
          description="print check button label"
          defaultMessage="Print"
        />
      }
      isLoading={isPrintBtnLoading}
      isDisabled={
        isPrintBtnDisabled ||
        cutOffPrintBtnDisabled ||
        printBtnDisabledOnRowFiltering
      }
    />
  );
};
